import React, { useContext, useEffect, useState } from 'react'

import { toast } from 'react-toastify'

import UserContext from 'contexts/UserContext'
import { usersUpdateAvatar } from 'requests/user'
import Avatar from 'components/avatar'

const SettingProfileFirstPart = () => {

  const { user, setUser } = useContext(UserContext)
  const [newImage, setNewImage] = useState(user?.user.avatar)


  useEffect(()=>{
    setNewImage(user?.user.avatar)
  },[user?.user.avatar])

 

 


const updateAvatar = async (selectedAvatrId:number) => {
  const id = user?.user?._id
  const token = user?.token?.accessToken

  if (!id || !token) {
    toast.error("Utilisateur non authentifié")
    return
  }
  try {
    const response = await usersUpdateAvatar(
      id,
      selectedAvatrId,
      token
    )
    if (response && user && selectedAvatrId) {
      setUser({
        ...user,
        user: {
          ...user.user,
          avatar: selectedAvatrId ,
        },
      })

      toast.success("Mise à jour de l'avatar effectuée")
    }
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'avatar :", error)
    toast.error("Erreur lors de la mise à jour de l'avatar")
  } finally {
    // setIsLoading(false)
  }
}


 
  return (
    <div>
        <h2 className='h1'>Mon compte</h2>

      <div className="flex  mt-8 items-center justify-center py-10 sm:py-5  gap-5 bg-[#F1F1FF]/50  rounded-[12px] ">
        <Avatar onSave={updateAvatar} ifUpdate={true} avatar={newImage} setAvatar={setNewImage} />

        <div className='flex flex-col'>
          <div className="text-[#5754E5] text-[18px] font-bold font-poppins ">
              {user?.user?.personalInfo?.lastName} {user?.user?.personalInfo?.firstName}
          </div>
          <div className="text-[#5754E5]/30 text-[14px]">
            {user?.user?.email}
          </div>
        </div>
      </div>
    

      
    </div>
  )
}
export default SettingProfileFirstPart
